import { ref } from 'vue'

/**
 * « Montre-lui la première tâche à cocher. »
 *
 * Une demande posée par un écran qui n'est pas celui des tâches (la carte
 * « Commence avec {prénom} », HARMONIA-93), et servie par la page de l'enfant
 * concerné dès qu'elle est visible et chargée. Au niveau du module : la
 * demande doit survivre à la navigation qui sépare les deux.
 */
const pendingChildId = ref<string | null>(null)

export function requestTaskSpotlight(childId: string): void {
  pendingChildId.value = childId
}

export function useTaskSpotlight() {
  /** Vrai si une demande attend cet enfant, et la retire : elle ne sert qu'une fois. */
  function consume(childId: string): boolean {
    if (!childId || pendingChildId.value !== childId) return false
    pendingChildId.value = null
    return true
  }

  return { pendingChildId, consume }
}
